import React from 'react';

let baseUrl = window.location.origin;

let websiteUrl, cmsUrl;

if (baseUrl == "http://localhost:3002") {
  websiteUrl = baseUrl;
  cmsUrl = "http://uatcms.pgrkam.com"
}
else if (baseUrl == "http://uatweb.pgrkam.com") {
  websiteUrl = baseUrl;
  cmsUrl = "http://uatcms.pgrkam.com"
}
else if (baseUrl == "http://pgrkam.com") {
  websiteUrl = baseUrl;
  cmsUrl = "http://cms.pgrkam.com"
}
else {
  websiteUrl = baseUrl;
  cmsUrl = "http://uatcms.pgrkam.com"
}


const WebPolicy = () => {

  return (
    <div className="tab-content">
      <div id="home" className=" tab-pane active">
        <section className="login-form mt-0">
          <div className="container">
            <div className="row">
              <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow   mb-3 mt-3  ">
                <div className="panel-heading">
                  <div className="mb-0">Punjab Rozgar Department</div>
                </div>
                <div className="panel-body p-policy pt-0  p-3 ">
                  <p className="mt-3">
                    <strong>Punjab Rozgar Department</strong> is an initiative by the Government of Punjab to provide every household in the state with access to job opportunities, skill development, and entrepreneurship support. The mission aims to bridge the gap between job seekers and employers, and foster self-employment and business growth across Punjab.
                  </p>

                  <p>
                    This website serves as the official portal for disseminating accurate, timely, and comprehensive information related to various services, schemes, and resources offered under Punjab Rozgar Department. It is designed to help job seekers, employers, skill providers, career counsellors, and entrepreneurs navigate and utilize government services effectively.
                  </p>

                  <p>
                    We have made consistent efforts to ensure that the information on this portal is up-to-date, accurate, and user-centric. Content is collaboratively curated and regularly reviewed by various departments involved in the Punjab Rozgar Department mission to maintain high standards of relevance, accessibility, and transparency.
                  </p>

                  <strong className='pb-2 d-block pHeading'>Key Policies & Governance Documents</strong>
                  <div className="policypage">
                    <a aria-label='Go to Copyright Policy page'
                      href={`${websiteUrl}/copyright-policy`} className="mb-2">✅ Copyright Policy</a>

                    <a aria-label='Go to CMAP policy page'
                      href={`${cmsUrl}/cmap-policy`} className="mb-2">✅ Content Contribution, Moderation, and Approval Policy (CMAP) </a>

                    <a aria-label='Go to Accessibility Statement page'
                      href={`${cmsUrl}/content-archival-(cap)-policy`} className="mb-2">✅ Content Archival Policy (CAP)</a>

                    <a aria-label='Go to Content Review Policy (CRP) page'
                      href={`${cmsUrl}/content-review-(crp)-policy`} className="mb-2">✅ Content Review Policy (CRP)</a>

                      <a aria-label='Go to Hyperlinking Policy page'
                      href={`${cmsUrl}/hyperlinking-policy`} className="mb-2">✅ Hyperlinking Policy</a>

                      <a aria-label='Go to Privacy Policy page'
                      href={`${websiteUrl}/privacy-policy`} className="mb-2">✅ Privacy Policy</a>

                      <a aria-label='Go to Terms & Conditions page'
                      href={`${cmsUrl}/terms-&-conditions`} className="mb-2">✅ Terms & Conditions</a>

                      <a aria-label='Go to Website Monitoring Plan page'
                      href={`${cmsUrl}/website-monitoring-plan`} className="mb-2">✅ Website Monitoring Plan</a>

                    <a aria-label='Go to Contingency Management Plan page'
                      href={`${cmsUrl}/contingency-management-plan`} className="mb-2">✅ Contingency Management Plan</a>

                    {/* <a href="" className="mb-2">✅ Content Contribution, Moderation, and Approval Policy (CMAP)</a> */}                                        

                    <a aria-label='Go to Security Policy page'
                      href={`${cmsUrl}/security-policy`} className="mb-2">✅ Security Policy</a>                    

                    <a aria-label='Go to Web Information Manager (WIM) page'
                      href={`${cmsUrl}/web-information-manager-(wim)`} className="mb-2">✅ Web Information Manager (WIM)</a>                    
                      
                  </div>

                  <strong className='pb-2 d-block pHeading'>User Engagement and Feedback</strong>
                  <p>
                    We thank you for visiting the official Punjab Rozgar Department portal and encourage you to explore our wide range of employment and entrepreneurship services. Your feedback is valuable in helping us improve the quality of content, usability, and services offered through this platform.
                  </p>
                  <p>
                    For queries or suggestions, please visit our <a>Contact Us</a> page.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div >
    </div >
  )
}

export default WebPolicy;